import { LoadSurgicalPendencyHistory } from 'domain/usecases/surgical-pendency/load-surgical-pendency-history'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteLoadSurgicalPendencyHistory
  implements LoadSurgicalPendencyHistory
{
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}
  load(
    surgical_pendency_id: number
  ): Promise<LoadSurgicalPendencyHistory.Model> {
    return this.surgicalPendencyRepository.loadSurgicalPendencyHistory(
      surgical_pendency_id
    )
  }
}
